export default __webpack_public_path__ + "static/media/linkdevice.705eea71.svg";